// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3319":"6a301097","6435":"6a301097","8162":"6a301097","8744":"6a301097"}[chunkId] + ".chunk.css";
};